import { render, staticRenderFns } from "./airlineProduct.vue?vue&type=template&id=b89b8e0c&scoped=true&"
import script from "./airlineProduct.vue?vue&type=script&lang=js&"
export * from "./airlineProduct.vue?vue&type=script&lang=js&"
import style0 from "./airlineProduct.vue?vue&type=style&index=0&id=b89b8e0c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b89b8e0c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b89b8e0c')) {
      api.createRecord('b89b8e0c', component.options)
    } else {
      api.reload('b89b8e0c', component.options)
    }
    module.hot.accept("./airlineProduct.vue?vue&type=template&id=b89b8e0c&scoped=true&", function () {
      api.rerender('b89b8e0c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/AirExport/airlineProduct.vue"
export default component.exports